import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const program_detailScreenModule = defineScreen({
  app: "coaching",
  screen_id: "program-detail",
  path: "/programs/:program_id",
  params: ["program_id"],
  heading: { text: "Programs", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "allow",
    "company_admin": "allow",
    "participant": "deny",
    "cohort_lead": "deny"
  },
  states: ["ready"],
  actions: [
    { id: "load", kind: "secondary", driver: "detail.load" }
  ],
  recipe: "Detail-1",
  data: { seedNeeds: ["readonly-walk-session", "populated-list-min1"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/program-detail.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default program_detailScreenModule;
